export function removeLocalStorageItems(keys: string[]) {
    keys.forEach((key) => {
        localStorage.removeItem(key);
    });
}

export function clearLocalStorage() {
    localStorage.clear();
}
